// extracted by mini-css-extract-plugin
export default {"content":"note_content__iJQnJ","icon":"note_icon__G5riu","title":"note_title__0edYm","sub_title":"note_sub_title__K4stQ","email":"note_email__LrqPl"};